import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import toast from 'react-hot-toast';
import api from '../../services/api';

export default function AdminSubscription() {
  const [plan, setPlan] = useState(null);
  const [loading, setLoading] = useState(true);
  const [portalLoading, setPortalLoading] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    api
      .get('/admin/me/plan')
      .then((res) => setPlan(res.data))
      .catch(() => setPlan(null))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    const checkout = searchParams.get('checkout');
    if (checkout === 'success') {
      toast.success('Paiement réussi. Votre abonnement est actif.');
      setSearchParams({});
      api.get('/admin/me/plan').then((res) => setPlan(res.data));
    } else if (checkout === 'cancelled') {
      toast('Paiement annulé.', { icon: 'ℹ️' });
      setSearchParams({});
    }
  }, [searchParams, setSearchParams]);

  const handleManageSubscription = () => {
    setPortalLoading(true);
    api
      .get('/billing/portal')
      .then(({ data }) => {
        if (data.url) window.location.href = data.url;
      })
      .catch((err) => {
        toast.error(err.response?.data?.message || 'Erreur d\'accès au portail.');
        setPortalLoading(false);
      });
  };

  if (loading) return <p className="text-gray-500">Chargement...</p>;

  const p = plan?.plan;
  const isPaid = p?.slug && p.slug !== 'free';

  return (
    <div className="max-w-2xl">
      <h1 className="text-2xl font-bold text-gray-800 mb-6">Mon abonnement</h1>
      <div className="bg-white rounded-xl shadow p-6 space-y-4">
        <div className="flex justify-between items-center">
          <span className="text-gray-500">Plan actuel</span>
          <span className={`font-semibold ${isPaid ? 'text-primary-600' : 'text-gray-700'}`}>
            {p?.name || 'Gratuit'}
          </span>
        </div>
        <div className="flex justify-between items-center">
          <span className="text-gray-500">Sondages créés</span>
          <span>{plan?.survey_count ?? 0}</span>
        </div>
        {p?.survey_limit != null && !p?.is_unlimited && (
          <div className="flex justify-between items-center">
            <span className="text-gray-500">Limite</span>
            <span>{plan?.remaining_surveys ?? 0} restant(s)</span>
          </div>
        )}
        {plan?.subscription_ends_at && (
          <div className="flex justify-between items-center">
            <span className="text-gray-500">Prochaine échéance</span>
            <span>{new Date(plan.subscription_ends_at).toLocaleDateString('fr-FR')}</span>
          </div>
        )}
        <div className="pt-4 border-t flex flex-wrap gap-3">
          <Link
            to="/pricing"
            className="inline-block px-4 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700"
          >
            {isPaid ? 'Changer d\'abonnement' : 'Passer à l\'abonnement'}
          </Link>
          {isPaid && (
            <button
              type="button"
              onClick={handleManageSubscription}
              disabled={portalLoading}
              className="inline-block px-4 py-2 bg-gray-100 text-gray-800 rounded-lg hover:bg-gray-200 disabled:opacity-50"
            >
              {portalLoading ? 'Chargement...' : 'Gérer mon abonnement'}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
